<phms-case-context-record-grid
  [appTerminologyIdentity]="sectionUsage.heading"
  [heading]="sectionText.heading()"
  itemLabelSingular="programming record"
  itemLabelPlural="programming records"
  [records]="records"
  [state]="state"
  [columnDefs]="columnDefs"
  [agGridOptions]="agGridOptions"
  [stateCopy]="{
    loadingText: 'Loading programming...',
    emptyText: 'No programming on file.',
    errorText: 'Programming is temporarily unavailable.',
  }"
></phms-case-context-record-grid>
